"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pagePropertiesSchema = exports.pageDataSchema = exports.basePageDataSchema = void 0;
/* eslint-disable prettier/prettier */
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../../core/schemaUtils");
var Image_schema_1 = require("../../core/image/Image.schema");
var Media_schema_1 = require("../../core/media/Media.schema");
var pageBackgroundDataRef = schemaUtils_1.createDataRef({ BackgroundMedia: Media_schema_1.BackgroundMediaSchema }).nullable();
exports.basePageDataSchema = yup.object({
    title: yup
        .string()
        .min(1)
        .max(100),
    hideTitle: yup.boolean(),
    icon: yup.string(),
    windowTitle: yup
        .string()
        .min(1)
        .max(512),
    descriptionSEO: yup.string().max(1024),
    metaKeywordsSEO: yup.string().max(512),
    pageTitleSEO: yup.string(),
    pageUriSEO: yup.string(),
    hidePage: yup.boolean(),
    underConstruction: yup.boolean(),
    tpaApplicationId: yup.number(),
    managingAppDefId: yup.string().nullable(),
    tpaPageId: yup.string(),
    pageSecurity: yup
        .object().shape({
        requireLogin: yup.boolean(),
        passwordDigest: yup.string().notRequired(),
        dialogLanguage: yup.string().notRequired(),
    })
        .nullable()
        .default({
        requireLogin: false,
        passwordDigest: '',
        dialogLanguage: '',
    }),
    indexable: yup.boolean().default(true),
    mobileHidePage: yup.boolean().nullable(),
    pageBackgrounds: yup.object().shape({
        desktop: yup.object().shape({
            custom: yup.boolean(),
            ref: pageBackgroundDataRef,
            isPreset: yup.boolean(),
        }),
        mobile: yup.object().shape({
            custom: yup.boolean(),
            mediaSizing: yup
                .mixed()
                .oneOf(['document', 'viewport'])
                .default('viewport'),
            ref: pageBackgroundDataRef,
            isPreset: yup.boolean(),
        }),
    }),
    isLandingPage: yup.boolean().default(false),
    isMobileLandingPage: yup.boolean().default(false),
    isPopup: yup.boolean().default(false),
    translationData: yup.object().shape({
        uriSEOTranslated: yup.boolean(),
    }),
    ogImageRef: schemaUtils_1.createDataRef({ Image: Image_schema_1.ImageSchema }).notRequired(),
    advancedSeoData: yup.string().notRequired(),
    characterSets: yup.array(yup.string()).notRequired(),
});
exports.pageDataSchema = schemaUtils_1.createDataSchema('Page', exports.basePageDataSchema);
// TODO need to write it fully
var viewModePropertiesSchema = yup.object().shape({
    minHeight: yup.number(),
    popup: yup.object().shape({
        closeOnOverlayClick: yup.boolean().default(true),
    }).notRequired()
});
exports.pagePropertiesSchema = schemaUtils_1.createPropertiesSchema('PageProperties', yup.object({
    desktop: viewModePropertiesSchema,
    mobile: viewModePropertiesSchema,
}));
//# sourceMappingURL=Page.schema.js.map